import React from 'react';
import { HQ } from '../sportConfig';
import SharedPullToRefresh from '../PullToRefresh.jsx';
export default function PullToRefresh({ storageKey = `${HQ.storagePrefix}-force-refresh` }) {
    return <SharedPullToRefresh storageKey={storageKey} />;
}
